// extracted by mini-css-extract-plugin
export default {"recycle-container":"index_recycle-container__Hnmyk"};